import * as Icons from '@ant-design/icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

let antdIcons = [];
for (let key in Icons) {
    if (key.indexOf("Filled") !== -1) {
        antdIcons.push(key);
    }
}

let faIcons = [];
for (let key in fas) {
    faIcons.push(key);
}

export function getAllIconNames() {
    return {
        antdIcons,
        faIcons
    }
};